import i18n from '@/lang';

export const columns = [
  // 客户编号
  // { prop: 'customerId', label: i18n.t('basicData.CustomerID'), width: 120, align: 'left' },
  // 客户名称
  { prop: 'customerName', label: i18n.t('basicData.CustomerName'), width: 160, align: 'left' },
  // 充值金额
  { prop: 'totalAmount', label: i18n.t('basicData.RechargeAmount'), width: 160, align: 'left' },
  // 退款金额
  { prop: 'refundAmount', label: i18n.t('basicData.RefundAmount'), width: 160, align: 'left' },
  // 预占用金额
  { prop: 'occupiedAmount', label: i18n.t('basicData.PreOccupiedAmount'), width: 160, align: 'left' },
  // 已扣款金额
  { prop: 'deductedAmount', label: i18n.t('basicData.DeductedAmount'), width: 160, align: 'left' },
  // 剩余可用金额
  { prop: 'availableAmount', label: i18n.t('basicData.RemainingAvailableAmount'), width: 160, align: 'left' },
  // 7天日均
  { prop: 'sevenDayAvgOccur', label: i18n.t('basicData.DailyAverageForTheLast7Days'), width: 160, align: 'left' },
  // 首次充值时间
  { prop: 'firstRechargeDate', label: i18n.t('basicData.FirstRechargeDate'), width: 160, align: 'left' },
  // 最近充值时间
  { prop: 'lastRechargeDate', label: i18n.t('basicData.LatestRechargeDate'), width: 160, align: 'left' }
];

